module.exports = __webpack_public_path__ + "static/media/banner-slide-4.3379ab39.jpg";